import { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '@context/AuthContext';

const NAV = [
  { to: '/admin', label: 'Dashboard', icon: '📊', end: true },
  { to: '/admin/orders', label: 'Orders', icon: '📦' },
  { to: '/admin/products', label: 'Products', icon: '🛍' },
  { to: '/admin/inventory', label: 'Inventory', icon: '🗃️' },
  { to: '/admin/customers', label: 'Customers', icon: '👥' },
  { to: '/admin/discounts', label: 'Discounts', icon: '🏷️' },
  { to: '/admin/analytics', label: 'Analytics', icon: '📈' },
  { to: '/admin/settings', label: 'Settings', icon: '⚙️' },
];

const S = {
  sidebar: { width: 240, minHeight: '100vh', background: 'linear-gradient(180deg,rgba(13,5,0,.99) 0%,rgba(20,4,46,.99) 100%)', borderRight: '1px solid rgba(255,184,0,.18)', display: 'flex', flexDirection: 'column', flexShrink: 0 },
  logo: { padding: '1.4rem 1.2rem', borderBottom: '1px solid rgba(255,184,0,.12)' },
  navLink: { display: 'flex', alignItems: 'center', gap: '.75rem', padding: '.65rem 1rem', borderRadius: 6, fontFamily: "'Cinzel',serif", fontSize: '.72rem', letterSpacing: '.1em', textTransform: 'uppercase', textDecoration: 'none', color: 'rgba(255,224,130,.5)', transition: 'all .2s', marginBottom: '.15rem' },
  navActive: { background: 'linear-gradient(90deg,rgba(255,107,0,.2),rgba(255,184,0,.1))', color: '#FFE082', borderLeft: '2px solid #FF6B00' },
};

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = () => { logout(); navigate('/admin/login'); };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#0D0500' }}>
      {/* Sidebar */}
      <aside style={{ ...S.sidebar, width: collapsed ? 60 : 240, transition: 'width .3s', position: 'sticky', top: 0, height: '100vh', overflowY: 'auto' }}>
        <div style={S.logo}>
          {!collapsed && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
              <span style={{ fontSize: '1.6rem', animation: 'glow 3s ease-in-out infinite' }}>ॐ</span>
              <div>
                <div style={{ fontFamily: "'Cinzel Decorative',serif", fontSize: '.85rem', background: 'linear-gradient(135deg,#FFE082,#FF6B00)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>CosmicHindu</div>
                <div style={{ fontFamily: "'Cinzel',serif", fontSize: '.5rem', letterSpacing: '.25em', textTransform: 'uppercase', color: '#FF6B00' }}>Admin Panel</div>
              </div>
            </div>
          )}
          {collapsed && <span style={{ fontSize: '1.6rem' }}>ॐ</span>}
        </div>

        <nav style={{ flex: 1, padding: '.8rem .6rem' }}>
          {NAV.map(item => (
            <NavLink key={item.to} to={item.to} end={item.end}
              style={({ isActive }) => ({ ...S.navLink, ...(isActive ? S.navActive : {}) })}>
              <span style={{ fontSize: '1.05rem', flexShrink: 0 }}>{item.icon}</span>
              {!collapsed && <span>{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        <div style={{ padding: '.8rem .6rem', borderTop: '1px solid rgba(255,184,0,.1)' }}>
          {!collapsed && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '.6rem', padding: '.6rem .4rem', marginBottom: '.5rem' }}>
              <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'linear-gradient(135deg,#FF6B00,#FFB800)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0D0500', fontWeight: 700, fontSize: '.85rem', flexShrink: 0 }}>A</div>
              <div>
                <div style={{ fontFamily: "'Cinzel',serif", fontSize: '.7rem', color: '#FFE082' }}>{user?.name || 'Admin'}</div>
                <div style={{ fontSize: '.62rem', color: 'rgba(255,224,130,.35)', fontFamily: "'Crimson Pro',serif" }}>{user?.email || 'admin@cosmichindu.com'}</div>
              </div>
            </div>
          )}
          <a href="/" style={{ ...S.navLink, color: 'rgba(255,224,130,.4)' }}>
            <span>🌐</span>{!collapsed && <span>View Store</span>}
          </a>
          <button onClick={handleLogout} style={{ ...S.navLink, background: 'none', border: 'none', cursor: 'pointer', width: '100%', color: 'rgba(255,107,0,.6)', textAlign: 'left' }}>
            <span>🚪</span>{!collapsed && <span>Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main */}
      <main style={{ flex: 1, padding: '2rem', overflowX: 'auto' }}>
        <Outlet />
      </main>
    </div>
  );
}
